'use strict';

// MODULES //

var isString = require( 'validate.io-string-primitive' ),
	isArray = require( 'validate.io-array' ),
	validate = require( './validate.js' ),
	defaults = require( './defaults.js' ),
	dget = require( './deepget.js' );


// FACTORY //

/**
* FUNCTION: factory( path[, opts] )
*	Creates a reusable deep get factory.
*
* @param {String|Array} path - key path
* @param {Object} [opts] - function options
* @param {String} [opts.sep='.'] - key path separator
* @returns {Function} deep get factory
*/
function factory( path, options ) {
	var isStr = isString( path ),
		props,
		opts,
		err;
	if ( !isStr && !isArray( path ) ) {
		throw new TypeError( 'deepGet()::invalid input argument. Key path must be a string primitive or a key array. Value: `' + path + '`.' );
	}
	opts = defaults();
	if ( arguments.length > 1 ) {
		err = validate( opts, options );
		if ( err ) {
			throw err;
		}
	}
	if ( isStr ) {
		props = path.split( opts.sep );
	} else {
		props = path;
	}
	/**
	* FUNCTION: deepGet( obj )
	*	Deep get a nested property.
	*
	* @param {Object|Array} obj - input object
	* @returns {*} nested property value
	*/
	return function deepGet( obj ) {
		if ( typeof obj !== 'object' || obj === null ) {
			return;
		}
		return dget( obj, props );
	};
} // end FUNCTION factory()


// EXPORTS //

module.exports = factory;
